export enum PopStatus {
  Down = 0,
  Up = 1,
  ParentDown = 2,
  Maintenance = 3,
  UnKnown = 4,
  UpsDowns=5

}

